import { ControlBase } from './control-base';

export class MetadataDropdown extends ControlBase<string>  {
    override controlType = 'dropdown';
}
